import 'lg-fullscreen/dist/lg-fullscreen';



// WEBPACK FOOTER //
// ./scripts/autoload/_lg-fullscreen.js